import spoke from '~/utils/spoke'

export default (context, inject) => {
  inject('spoke', spoke)
}
